/**
 * @generated SignedSource<<dbfe474c299967f192fece162a5a897b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModule_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleVariant_user">;
  readonly " $fragmentType": "HpSharedFeaturedModule_user";
};
export type HpSharedFeaturedModule_user$key = {
  readonly " $data"?: HpSharedFeaturedModule_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModule_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isSaleVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModule_user",
  "selections": [
    {
      "condition": "isSaleVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedFeaturedModuleVariant_user"
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3964e38294f491eccab85a3d878b94e8";

export default node;
